import React, { useState, useEffect } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './SelfcareInformsView.css';

import { apiUrl } from '../../../utility/Connections';

import { Typography, Layout, Select, Button, message } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import TableRelationshipsFinished from '../../../components/tableRelationshipsFinished/tableRelationshipsFinished';

const { Title } = Typography;
const { Content } = Layout;
const { Option } = Select;

const SelfcareInformsView = ({ srvId = 6, title = "Informes" }) => {
    const isSuperAdmin = localStorage.getItem('is_superuser') === 'true';

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");

    const [dataEvaluations, setDataEvaluations] = useState([]);
    const [selectedEvaluation, setSelectedEvaluation] = useState(null);

    const [individualResults, setIndividualResults] = useState([]);
    const [totalResults, setTotalResults] = useState({});
    const [resultsPagination, setResultsPagination] = useState({ page: 1, pageSize: 20, total: 0 });

    const showSwal = (text, type, title) => {
        let swalType = ["error", "warning", "success"][type] || "info";

        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        });
    };

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setDataEvaluations([]);
            setSelectedEvaluation(null);
            setIndividualResults([]);
            setTotalResults({});
            getEvaluations(current_org.org_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [srvId]);

    const getEvaluations = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/evaluations/get-full-evaluations/${orgId}/${srvId}/`, headers)
            .then(function (response) {
                const data = response.data;
                if (data.length > 0) {
                    const lastEvaluation = data[data.length - 1];
                    setSelectedEvaluation(lastEvaluation);
                    getEvaluationResults(lastEvaluation.evl_id);
                }
                setDataEvaluations(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getEvaluationResults = async (evl_id, page = 1, pageSize = 20) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/informs/get-evaluation-results/${evl_id}/?page=${page}&page_size=${pageSize}`, headers)
            .then(function (response) {
                const data = response.data;
                setIndividualResults(data.results);
                setTotalResults(data.totals);
                if (data.pagination) {
                    setResultsPagination({
                        page: data.pagination.page,
                        pageSize: data.pagination.page_size,
                        total: data.pagination.total,
                    });
                }
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const seeGeneralInform = () => {
        const rootUrl = window.location.origin;
        const url = `${rootUrl}/informes/general/${selectedEvaluation.evl_id}`;
        window.open(url, '_blank');
    };

    const handleOnChangeEvaluation = (evlId) => {
        const selected = dataEvaluations.find((evl) => evl.evl_id === evlId);
        if (selected) {
            setSelectedEvaluation(selected);
            getEvaluationResults(selected.evl_id, 1, resultsPagination.pageSize || 20);
        }
    };

    const handleIndividualTablePageChange = (page, pageSize) => {
        if (!selectedEvaluation?.evl_id) return;
        getEvaluationResults(selectedEvaluation.evl_id, page, pageSize || resultsPagination.pageSize || 20);
    };

    const downloadEvaluationExcel = async () => {
        setShowLoading(true);
        setLoadingText("Generando archivo. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
            responseType: 'blob'
        };

        try {
            const response = await axios.get(`${apiUrl}/informs/export-evaluation-results-excel/${selectedEvaluation.evl_id}/`, headers);

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Resultados ${selectedEvaluation.evl_title}.xlsx`);
            document.body.appendChild(link);
            link.click();

            link.remove();
            window.URL.revokeObjectURL(url);
            setShowLoading(false);
            message.success("Archivo descargado");
        } catch (error) {
            setShowLoading(false);
            console.error("Error exportando el archivo:", error);
            message.error("Error exportando el archivo");
            showSwal("Error exportando el archivo", 0, "Error");
        }
    };

    const downloadTycAcceptancesExcel = async () => {
        if (!selectedEvaluation) return;
        setShowLoading(true);
        setLoadingText("Generando archivo de firmas...");

        const token = localStorage.getItem('access_token');

        try {
            const response = await axios.get(
                `${apiUrl}/terms-conditions/download-acceptances/${selectedEvaluation.evl_id}/?decision=ACEPTO`,
                {
                    headers: { 'Authorization': `Bearer ${token}` },
                    responseType: 'blob',
                }
            );

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Firmas_ProteccionDatos_${selectedEvaluation.evl_title}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            setShowLoading(false);
            message.success('Archivo de firmas descargado');
        } catch (error) {
            setShowLoading(false);
            console.error('Error descargando firmas:', error);
            message.error('Error descargando el archivo de firmas');
        }
    };

    return <div className='main-container'>
        {showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />}

        {dataEvaluations.length === 0 && <Content className='main-subcontainer main-subcontainer-column'>
            <Title type='primary' level={4}>No se encontraron evaluaciones</Title>
        </Content>}

        {dataEvaluations.length > 0 && <Content className='main-subcontainer main-subcontainer-column'>
            <div className='external-sub-header'>
                <Title type='primary' level={2}>{title}</Title>
                <Select
                    style={{ width: 400 }}
                    value={selectedEvaluation?.evl_id}
                    onChange={handleOnChangeEvaluation}
                >
                    {dataEvaluations.map((row) => (
                        <Option key={row.evl_id} value={row.evl_id}>
                            {row.evl_title}
                        </Option>
                    ))}
                </Select>
            </div>

            {totalResults?.average_by_dimension && <div className='layout-content'>
                <div className='display-center-row align-full-center' style={{ marginTop: 20, marginBottom: 20 }}>
                    <Button type='primary' onClick={seeGeneralInform}>
                        Ver informe general completo
                    </Button>
                    <Button style={{ marginLeft: 8 }} type='primary' onClick={downloadEvaluationExcel}>
                        Ver informe general completo Excel
                    </Button>
                    {isSuperAdmin && (
                        <Button style={{ marginLeft: 8 }} onClick={downloadTycAcceptancesExcel}>
                            Descargar firmas protección de datos
                        </Button>
                    )}
                </div>
                <TableRelationshipsFinished
                    individualResults={individualResults}
                    selectedEvaluation={selectedEvaluation}
                    pagination={resultsPagination}
                    onPageChange={handleIndividualTablePageChange}
                />
            </div>}
        </Content>}
    </div>;
};

export default SelfcareInformsView;
